/* eslint-disable */ 
import React from 'react'
import '../aboutUs/AboutUs.css'
import './style.css'

import scholorImage3 from '../../../assets/images/scholorimg-3.png';
import scholorImage1 from '../../../assets/images/scholorimg-1.png';
import scholorImage2 from '../../../assets/images/scholorimg-2.png';

const Regulations = () => {
    return (
        <>
            <section id="banner-wrap2">
                <div className="container">
                    <div className="banner-content">
                        <h1>Rules and Regulations</h1>
                        <ul className="breadcrumb">
                            <li><a href="/">Home</a></li>
                            <li>Rules and Regulations</li>
                        </ul>
                    </div>
                </div>
            </section>

            <article className="innerpage">
                <section id="simplestep">
                    <div className="container">
                        <div className="simplestep-content">
                            <div className="simplestep-heading">
                                <h6>Start In The Name Of Allah</h6>
                                <h2>Follow the instructions</h2>
                                <h3>For Tutors</h3>
                                <p>
                                    1.	There should not be unnecessary disturbances or background noise during the Class.
                                </p>
                                <p>
                                    2.	The teacher must not be late for the class, all classes must commence on the scheduled time, if the teacher is late more then once then appropriate steps against the teacher will be taken.
                                </p>
                                <p>
                                    3.	The class should not be left earlier then its due completion time.
                                </p>
                                <p>
                                    4.	If the teacher has to miss a scheduled class due to some personal emergency, then he/she has to inform the students in advance and reschedule the class.
                                </p>
                                <p>
                                    5.	The mode of communication should be respectful, and the teacher should be professional in his conduct with the student.
                                </p>
                                <p>
                                    6.	The teachers inactive on the platform for more then three weeks will be removed.
                                </p>
                                <p>
                                    7.	The profile information should be filled out in complete and honestly, if the teacher is found out to have filled fake information then appropriate steps against him will be taken.
                                </p>
                                <p>
                                    8.	The management is not to be harassed by the teacher about any matter. Full support will be provided to the teacher at every step of the way.
                                </p>
                                <p>
                                    9.	The web portal is to be used to convey authentic knowledge only, extremism is always to be avoided when it comes to teaching Islamic literature. Any teacher found guilty of any sort of suspicious activity will be dealt with seriously.
                                </p>
                                <b>Barak Allahu Feekum!</b>
                            </div>
                            <br/>
                            <hr/>
                            <br/>
                            <div className="simplestep-heading">
                                <h2>Follow the instructions</h2>
                                <h3>For Students</h3>
                                <p>
                                    1.	A respectful demeanour towards the teacher must be adopted during the class, otherwise the management will take serious action
                                </p>
                                <p>
                                    2.	The scheduled class time should be respected, and the student should not be late for class. If there are any concerns the student can contact the teacher at any time.
                                </p>
                                <p>
                                    3.	The platform should only be used to contact teachers for personal education and should not be used to search for teachers to hire them for any other institutes, in such cases the student’s profile will be blocked.
                                </p>
                                <p>
                                    4.	The student can choose more then one teacher as a tutor to learn from.
                                </p>
                                <p>
                                    5.	There should not be any fake information added to the personal profile or at the payment process.
                                </p>
                                <p>
                                    6.	The student is encouraged to inform the teacher in cases where due to some emergency or personal reason he/she will be late or miss the scheduled class.
                                </p>
                                <p>
                                    7.	The misuse of the system has to be avoided at all times. Conversation involving extremist’ views are to be avoided and the platform is not going to be used to hold political discussion.
                                </p>

                                <b>Jazakum Allahu Khair!</b>
                            </div>

                        </div>
                    </div>
                </section>
            </article>

        </>
    )
}

export default Regulations
